export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">移动观影</h2>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-[480px] mx-auto lg:mx-0 mb-6">
              天美影视全面适配移动端浏览器，无需下载安装即可在手机上享受高清流畅的观影体验。随时随地，打开浏览器就能畅享海量影视资源。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50/10 rounded-xl border border-background-50/10">
                <div className="w-10 h-10 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-android-line text-primary-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-medium text-background-50">Android 端</div>
                  <div className="text-xs text-foreground-400">浏览器直接访问</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50/10 rounded-xl border border-background-50/10">
                <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-apple-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-medium text-background-50">iOS 端</div>
                  <div className="text-xs text-foreground-400">Safari 流畅观影</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 max-w-[360px]">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-r from-primary-500/30 via-accent-500/20 to-primary-500/30 rounded-[2.5rem] blur-xl"></div>
              <div className="relative bg-background-900 rounded-[2rem] p-3 border border-background-50/10">
                <div className="bg-background-800 rounded-2xl overflow-hidden aspect-[9/16]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20streaming%20app%20interface%20with%20movie%20thumbnails%2C%20dark%20theme%20with%20warm%20red%20and%20golden%20accents%2C%20modern%20UI%20design%2C%20premium%20entertainment%20app%20feel%2C%20no%20text%20no%20people%2C%20clean%20composition&width=720&height=1280&seq=app-mobile-mockup&orientation=portrait"
                    alt="天美影视手机端观影界面"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}